import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import CustomFileInput from "@/_MiniApps/RemainingPaymentComponent/components/PaymentMethods/CustomFileInput/CustomFileInput";
var BanksSections = function BanksSections(_ref) {
  var banks = _ref.banks,
    banksState = _ref.banksState,
    setSelectedFile = _ref.setSelectedFile,
    removeSelectedFile = _ref.removeSelectedFile,
    enableAllPayments = _ref.enableAllPayments,
    order = _ref.order,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab,
    isCopySuccess = _ref.isCopySuccess,
    copySuccessText = _ref.copySuccessText,
    handleCopy = _ref.handleCopy;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  if (!banks || banks.length === 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, banks.map(function (item, idx) {
    var _order$paymentOptions;
    var isOpen = activeTab === idx + 1;
    var isPending = !(order && !((_order$paymentOptions = order.paymentOptions) !== null && _order$paymentOptions !== void 0 && _order$paymentOptions.enabled) || item.enabled);
    return /*#__PURE__*/React.createElement("li", {
      key: idx,
      className: ["flex flex-wrap justify-between items-center px-2 py-3 border border-gray-gainsboro rounded-lg relative mb-3 border-solid", banksState[item.id] ? "border-[#00b362]" : "", !enableAllPayments ? "pointer-events-none bg-[#e8eff6]" : "", isPending ? "border-[#0D0DB5]" : "", isOpen ? "border-[#0D0DB5]" : ""].join(" ")
    }, !isPending ? /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between cursor-pointer flex-[100%]",
      onClick: function onClick() {
        return setActiveTab(isOpen ? -1 : idx + 1);
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item.icon,
      alt: ""
    }), banksState[item.id] ? /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/Check.svg",
      alt: ""
    }) : /*#__PURE__*/React.createElement("img", {
      className: "transition-transform duration-300 ".concat(isOpen ? "rotate-180" : ""),
      src: CDN_LINK + "/assets/images/remaining-arrow.svg",
      alt: ""
    })) : /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between cursor-auto flex-[100%]"
    }, /*#__PURE__*/React.createElement("img", {
      src: item.icon,
      alt: ""
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", {
      className: "text-[#0D0DB5] text-xs leading-4 mt-4 block"
    }, t("payment_under_review", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[#0D0DB5] text-xs leading-4 mt-1"
    }, t("syarah_customer_service_team_contact", {
      ns: "web_common"
    })))), isOpen && /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pt-5"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[#6c7a8d] text-sm font-semibold leading-6"
    }, t("beneficiary_name", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between mb-4"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-sm leading-4 text-black"
    }, t("syarah_trading_company", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("button", {
      className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0",
      onClick: function onClick(e) {
        return handleCopy(e, idx, false);
      }
    }, t("copy", {
      ns: "web_common"
    }))), /*#__PURE__*/React.createElement("span", {
      className: "text-[#6c7a8d] text-sm font-semibold leading-6"
    }, t("account_number", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between mb-4"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-sm leading-6 text-black"
    }, item.accountNumber), /*#__PURE__*/React.createElement("button", {
      className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0",
      onClick: function onClick(e) {
        return handleCopy(e, idx, false);
      }
    }, t("copy", {
      ns: "web_common"
    }))), /*#__PURE__*/React.createElement("span", {
      className: "text-[#6c7a8d] text-sm font-semibold leading-6"
    }, "IBAN"), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between mb-4"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-sm leading-6 text-black"
    }, item.iban), /*#__PURE__*/React.createElement("button", {
      className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0",
      onClick: function onClick(e) {
        return handleCopy(e, idx, false);
      }
    }, t("copy", {
      ns: "web_common"
    }))), /*#__PURE__*/React.createElement(CustomFileInput, {
      bankName: item.id,
      selectedFile: banksState[item.id],
      setSelectedFile: setSelectedFile,
      removeSelectedFile: removeSelectedFile
    })), isCopySuccess === idx && /*#__PURE__*/React.createElement("div", {
      className: "absolute left-0 top-0 w-full h-full flex justify-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "mt-[91px] min-w-[172px] w-fit h-min min-h-8 flex justify-center items-center bg-[rgba(108,122,141,0.75)] rounded-2xl text-white text-xs leading-8 px-3"
    }, t("copied", {
      ns: "web_common"
    }), " ", copySuccessText))));
  }));
};
export default BanksSections;